import { apiRequest } from "./apiClient";

export function createLead(payload) {
  return apiRequest("/leads", {
    method: "POST",
    body: payload,
  });
}

export function fetchPricing() {
  return apiRequest("/pricing");
}
